// extracted by mini-css-extract-plugin
module.exports = {"language-selector-wrapper":"languageSelectorWrapper_language-selector-wrapper__OtePt"};